module.exports = __webpack_public_path__ + "static/tutorial2-0447c6ae40fcb3eebde58200d0c0edc5.png";